module.exports = __webpack_public_path__ + "img/s4-2.b0e2b219.svg";